import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ModalService } from '../../../service/modal.service';
import { GlobalService } from '../../../service/global.service';
import { environment } from '../../../environments/environment';
import { AvaliacaoApiService } from '../../../service/api/avaliacao.api';




@Component({
  selector: 'app-avaliacao-modal',
  templateUrl: './avaliacao-modal.component.html',
  styleUrls: ['./avaliacao-modal.component.css']
})
export class AvaliacaoModalComponent implements OnInit, OnDestroy {

  constructor(
    public modalService: ModalService, 
    public globalService: GlobalService, 
    private route: ActivatedRoute, 
    private avaliacaoService: AvaliacaoApiService,
    private formBuilder: FormBuilder) { }

  avaliacaoForm: FormGroup | undefined; // Formulário com validação
  sub: any;
  codModeloFta: number = 0;
  modulo: string = '';
  avaliacaoPrincipal = 0;
  avaliacaoComplementar: { [key: number]: string[] } = {};
  textoComplementar = new FormControl('', [Validators.maxLength(255)]);
  nomeApp = environment.nomeApp;
  usuario: any = '';

  ngOnInit() {

    this.avaliacaoForm = this.formBuilder.group({
      textoComplementar: this.textoComplementar
    });

    this.sub = this.route
      .queryParams
      .subscribe(params => {
        if (params['codModeloFta'] != '') {
          this.codModeloFta = params["codModeloFta"];
        }
      });
      if (this.globalService.estaAutenticado()) {
        this.usuario = this.globalService.getUsername();
      }

    this.avaliacaoService.buscarUltimaAvaliacao(this.usuario, this.nomeApp)
      .subscribe(
        avaliacao => {
          console.log('ultima avaliacao:' + avaliacao);
          this.avaliacaoPrincipal = avaliacao.avaliacaoPrincipal;
          this.avaliacaoComplementar[avaliacao.avaliacaoPrincipal] = avaliacao.avaliacaoComplementar;
          this.textoComplementar.setValue(avaliacao.textoComplementar);
        },
        error => {
          if (error.status === 404) {
            console.log('Usuário não possui avaliação');
          } else {
            console.log(error);
            this.modalService.exibirMensagem('Erro', error.message, 'Fechar');
          }
        }
      );
  }

  ngOnDestroy() {
    this.globalService.loading = false;
  }


  textosAvaliacao: { [key: number]: string } = {
    1: 'Muito Insatisfeito',
    2: 'Insatisfeito',
    3: 'Neutro',
    4: 'Satisfeito',
    5: 'Muito Satisfeito'
  };

  opcoesDetalhadas: { [key: number]: string[] } = {
    1: ['Apresentou muitos erros', 'Estava muito lento', 'Travou muito', 'Não consegui utilizar'],
    2: ['Apresentou alguns erros', 'Estava lento', 'Travou', 'Achei confuso'],
    3: ['Erros intermitentes', 'Um pouco lento', 'Pouco Prático', 'É incompleto'],
    4: ['É intuitivo', 'É prático', 'É rápido', 'Boa usabilidade'],
    5: ['Muito intuitivo', 'Muito prático', 'Muito rápido', 'É completo']
  };


  setAvaliacaoPrincipal(nivel: number) {
    this.avaliacaoPrincipal = nivel;
    this.avaliacaoComplementar[nivel] = [];
  }

  toggleOpcao(nivel: number, opcao: string) {
    const index = this.avaliacaoComplementar[nivel].indexOf(opcao);
    if (index !== undefined && index >= 0) {
      this.avaliacaoComplementar[nivel].splice(index, 1);
    } else {
      this.avaliacaoComplementar[nivel].push(opcao);
    }
  }

  enviarAvaliacao() {

    if (this.avaliacaoPrincipal > 0) {
      let dadosGerados = {
        "avaliacaoPrincipal": this.avaliacaoPrincipal,
        "avaliacaoComplementar": this.avaliacaoComplementar[this.avaliacaoPrincipal] || [],
        "textoComplementar": this.textoComplementar.value,
        "nomeApp": this.nomeApp,
        "usuario": this.usuario,
        "codModeloFta": this.codModeloFta
      };

      this.avaliacaoService.enviarAvaliacao(dadosGerados)
          .pipe(
            finalize(() => {
              this.globalService.loading = false;
            }))
          .subscribe(
            avaliacao => {
              console.log(avaliacao);
              this.modalService.incluirDadosGerados(dadosGerados);
              this.modalService.exibirMensagem('Ok', "Avaliação realizada com sucesso!", 'Fechar');
            },
            err => {
              console.log(err);
              if (err.status === 406) {
                this.modalService.exibirMensagem('Atenção!', err.error, 'Fechar');
              } else {
                this.modalService.exibirMensagem('Erro', err.message, 'Fechar');
              }

            }
          );
    }else {
      this.modalService.exibirMensagem('Erro', "Avaliação inválida! Revise sua avaliação", 'Fechar');
    }
  }

  verificarValidade(): any {
    if (this.textoComplementar.valid) {
      return false;
    }else {
      return true;
    }
  }

  cancelar() {
    this.globalService.loading = false;
    this.avaliacaoPrincipal = 0;
    this.avaliacaoComplementar = {};
    this.textoComplementar.setValue('');
    this.modalService.fecharPaginaModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/modal/avaliacao-modal/avaliacao-modal.component.ts